import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templateIntegrationsMarketplaceAppContainer = document.createElement('template');

templateIntegrationsMarketplaceAppContainer.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>


  <div class="wrapper">
      <header class='page__header'>
        <gz-title id="main_title" fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.TITLE}'></gz-title>
      </header>
      <div class="header-banner">
        <gz-title fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.TITLE}' id="banner-title"></gz-title>
        <gz-text fontSize="${FontSizes.HEADING_6}" fontWeight="${FontWeights.NORMAL}" id="banner-text"></gz-text>
        <gz-button id="banner-btn" type="full" color="primary" theme="dark"></gz-button>
      </div>
      <gz-grid-filters class="grid-filters"></gz-grid-filters>
      <div class="d-flex justify-between align-center" style="max-width: 80%;">
          <gz-title id='installed_integrations' class="section-title" fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.HEADING_4}'></gz-title>
          <gz-icon-button
              id="gridDataRefresh"
              class="grid-refresh"
              icon="ds-icon-refresh"
              size="24"
              fontsize="20"
              buttontype="square"
              buttonfill="quiet"
              buttoncolor="secondary">
          </gz-icon-button>
      </div>
      <div class="installed-grid-wrapper">
        <gz-integrations-marketplace-grid-installed class="integrations-marketplace-grid"></gz-integrations-marketplace-grid-installed>
      </div>
      <div class="installed-grid-empty-state">
        <gz-image-repo state="no-data-integrations">
          <gz-title fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.BODY}' id="empty-state-installed-grid-title"></gz-title>
          <gz-text fontWeight="${FontWeights.NORMAL}" fontSize="${FontSizes.PARAGRAPH_13}" id="empty-state-installed-grid-text"></gz-text>
        </gz-image-repo>
      </div>
      <gz-title id='available_integrations' class="section-title" fontWeight='${FontWeights.MEDIUM}' fontSize='${FontSizes.HEADING_4}'></gz-title>
      <gz-integrations-marketplace-grid-available class="integrations-marketplace-grid"></gz-integrations-marketplace-grid-available>
  </div>
 <gz-side-menu menuWidth="400"></gz-side-menu>
`;
